import React = require('react');

import { beaconComponentRegistryEntry, getUserAccountSettingsURL } from '~src/beacon/BeaconComponentRegistryFunctions';
import { DeepLink } from '~src/beacon/deepLink/DeepLink';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { UserNotificationsUserSettings } from '~src/userNotifications/components/settings/UserNotificationsUserSettings';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { DataAlertNotification } from './SuspendedDataAlertSetting';
import { SubscriptionNotification } from './SuspendedSubscriptionSetting';

const DEEPLINK_ID = 'user-notification-preferences';

export type NotificationsSettingsProps = {
  siteUser: ISiteUserInfo;
  serverUser: IServerUserInfo;
  userHasNoSiteId: boolean;
  isViewerAdmin: boolean;
  isUserNotificationsPlatformEnabled?: boolean;
}

export function NotificationsSettings(props: NotificationsSettingsProps): JSX.Element {
  return (
    <>
      <h2 className={UserSettingsStyle.titleText}>{Messages.userNotificationSettingsLabel()}</h2>
      <table>
        <tbody>
          {props.isUserNotificationsPlatformEnabled &&
            <tr>
              <td className={UserSettingsStyle.tbody} colSpan={2}>
                <DeepLink deepLinkId={DEEPLINK_ID}>
                  <table>
                    <tbody className={UserSettingsStyle.tbody}>
                      <tr data-tb-test-id="userSettings-user-notifications-platform">
                        <UserNotificationsUserSettings />
                      </tr>
                    </tbody>
                  </table>
                </DeepLink>
              </td>
            </tr>}
          {props.isViewerAdmin &&
            <>
              {props.isUserNotificationsPlatformEnabled && UserSettingsHelper.getSectionDividerLine()}
              <tr>
                <td className={UserSettingsStyle.tbody} colSpan={2}>
                  <SubscriptionNotification {...props} />
                </td>
              </tr>
              {UserSettingsHelper.getSectionDividerLine()}
              <tr>
                <td className={UserSettingsStyle.tbody} colSpan={2}>
                  <DataAlertNotification {...props} />
                </td>
              </tr>
            </>
          }
        </tbody>
      </table>
    </>
  );
}

export const NotificationPreferencesSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.userNotificationSettingsLabel(),
  deeplinkId: DEEPLINK_ID,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  tags:  () => { return [Messages.userSettings_Preference_Header(), Messages.email(), Messages.slack(), Messages.teams()]; },
  isAdmin: false,
  isVisible: () => getSessionManagementServiceInstance().isUserNotificationsPlatformEnabled()
});